@if (isLoadingResults || isRateLimitReached) {
<div class="spinner">
  @if (isLoadingResults) {
  <mat-spinner></mat-spinner>
  }
</div>
}
<div class="librerias-container seccion-media" *ngIf="!isLoadingResults">
  <h2>Nos encontrás también en estas librerías</h2>
  <ul class="librerias" *ngFor="let libreria of librerias">
    <li>
      <a [href]="libreria.googleMapsUrl">
        <h3>{{ libreria.name }}</h3>
        <span>{{ libreria.address }}</span>
      </a>
    </li>
  </ul>
</div>